import React from 'react';
import SignIn from './sign-in';
import {useAuthorizationState} from './authorization';

export default React.memo(({children}) => {
    const authorizationState = useAuthorizationState();
    return (
        <>{authorizationState ? <>{children}</> : <>{<SignIn/>}</>}</>
    );
});